// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".maxWidth[data-v-70d08304]{max-width:100%}.avoidClick[data-v-70d08304]{pointer-events:none}.materialGreen[data-v-70d08304]{color:#388e3c}.materialRed[data-v-70d08304]{color:#d32f2f}.materialBlue[data-v-70d08304]{color:#303f9f}.materialGrey[data-v-70d08304]{color:#616161}", ""]);
// Exports
module.exports = exports;
